export const TOGGLE_EXPAND_MENU_ITEM = 'TOGGLE_EXPAND_MENU_ITEM'

export const CLOSE_MENU = 'CLOSE_MENU'

export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR'

export const TOGGLE_WITHOUT_ANIMATION = 'TOGGLE_WITHOUT_ANIMATION'

export const SET_SALE_TYPE = 'SET_SALE_TYPE'

export const SET_CURRENT_ITEMS = 'SET_CURRENT_ITEMS'

export const SET_CURRENT_MAP = 'SET_CURRENT_MAP'

export const ASSIGN = 0

export const EN_ROUTE = 1

export const DELIVERED = 2

export const TA_INSTORE = 3

export const TA_DELIVERED = 4

export const NONE = -1



// WEBPACK FOOTER //
// ./src/store/mutation-types.js